import { GridRowParams } from "@mui/x-data-grid";
import React, { useEffect } from "react";
import AppGrid from "../../../app/AppGrid";
import { DmsManufacturer } from "../../../../models/features/ShoppingPortal/DmsManufacturer";
import { AppGridId } from "../../../../models/app/AppGridModels";

interface ManufacturerGridProps {
  data: DmsManufacturer[];
  isLoading: boolean;
  columns: any;
  selectedRows: any[];
  onSelect: any;
}
const ManufacturerGrid: React.FunctionComponent<ManufacturerGridProps> = ({
  data,
  isLoading,
  columns,
  selectedRows,
  onSelect,
}) => {
  return (
    <>
      <AppGrid
        gridId={AppGridId.DMS_Manufacturers}
        getRowId={(row) => row.manufacturerId}
        data={data?.map((item: any, index: any) => ({
          ...item,
          id: item.manufacturerId,
        }))}
        isLoading={isLoading}
        columns={columns}
        height={571}
        isRowSelectable={(params: GridRowParams) =>
          params.row.catalogManufacturer !== undefined &&
          params.row.catalogManufacturer !== null
        }
        selectedRows={selectedRows}
        onSelect={onSelect}
      ></AppGrid>
    </>
  );
};

export default ManufacturerGrid;
